var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"restQuestionCountContainer"},[_c('span',{staticClass:"questionCountLabel"},[_vm._v("あと"+_vm._s(_vm.restQuestionCount)+"問")])])}
var staticRenderFns = []

export { render, staticRenderFns }